// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"132":"e6d7b4eb","170":"f126a377","196":"4cd4820c","571":"e5dcf6b3"}[chunkId] + ".css";
};